const APROBADOR = 'aprobador'
const SOLICITANTE_SINDICAL = 'solicitante-sindical'
/**
 * Permisos sindicales
 */
const PS = Object.assign({
    SOLICITANTE_SINDICAL: 'solicitante-sindical',
    BP: 'business-partner',
    APROBADOR: 'aprobador',
    RELACIONES_LABORALES: 'relaciones-laborales',
})

/*
* Roles de HT 
*/ 
const HEALTH_TRACKER = Object.assign({
    OH_ANALYST: Object.assign({
        code: 'oh-analyst',
        _id: 17
    }),
    OH_LEAD: Object.assign({
        code: 'oh-specialist',
        _id: 18
    }),
    RESPONSIBLE_INFORMATION: Object.assign({
        code: 'responsable-info',
        _id: 19
    }),
    OCCUPATIONAL_DOCTOR: Object.assign({
        code: 'medico-laboral',
        _id: 20
    })
})

export {
    HEALTH_TRACKER,
    PS,
    APROBADOR,
    SOLICITANTE_SINDICAL
}